const isset = v => v !== undefined && v !== null && v !== "";
const requiredError = ["This field is required"];

export default {
  methods: {
    validateNumber(field) {
      const max = field.max === null ? NaN : Number(field.max);
      const min = field.min === null ? NaN : Number(field.min);
      if (!isNaN(max) && !isNaN(min)) {
        return value => {
          if (field.required && !isset(value)) {
            return requiredError;
          }
          return Number(value) >= min && Number(value) <= max
            ? []
            : [`Value must be between ${min} and ${max}`];
        };
      } else if (!isNaN(max)) {
        return value => {
          if (field.required && !isset(value)) {
            return requiredError;
          }
          Number(value) <= max
            ? []
            : [`Value must be less than or equal to ${max}`];
        };
      } else if (!isNaN(min)) {
        return value => {
          if (field.required && !isset(value)) {
            return requiredError;
          }
          Number(value) >= min
            ? []
            : [`Value must be greater than or equal to ${min}`];
        };
      }
      return field.validator;
    }
  }
};
